'use strict';

function ViewDirective ($animate, $window) {

  var animDuration = 500;

  var link = function (scope, $el, attrs, ctrls) {
    var ctrl = ctrls[0];
    var parentCtrl = ctrls[1];
    var pageId = parentCtrl.getId();

    ctrl.init(pageId);

    $el.addClass('sb-nav-drawer-page-view hide');

    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    /////////////////////////////////////////////////////////////////////////////////////////////////

    scope.$on('sbDrawer:change', function(ev, delta, drawerAnimating) {
      var isCurrentView = pageId === delta.page.current && ctrl.id === delta.view.current;
      var isPreviousView = pageId === delta.page.previous && ctrl.id === delta.view.previous;
      if(!(isPreviousView || isCurrentView)) {
        return; // Doesn't concern this view
      }

      var pos1, pos2;
      var animationClasses;

      if(drawerAnimating || delta.page.previous !== delta.page.current) {
        if(isCurrentView) {
          $el.removeClass('hide');
          ctrl.visible = true;
        } else { // Away from it
          $el.addClass('hide');
          ctrl.visible = false;
        }

      } else {

        if(isCurrentView) {
          // we are changing to this view
          pos1 = ctrl.getPos(delta.view.current);
          pos2 = ctrl.getPos(delta.view.previous);

          if (pos1 > pos2) {
            animationClasses = 'animated slideInRight';
          } else {
            animationClasses = 'animated fadeIn';
          }

          $el.addClass(animationClasses);
          ctrl.visible = true;
          $animate.removeClass($el, 'hide').then(function () {
            $el.removeClass(animationClasses);
          });

        } else {
          // changing away from this view...
          // do animation using newView as a reference
          pos1 = ctrl.getPos(delta.view.current);
          pos2 = ctrl.getPos(delta.view.previous); // current view

          // if current view (oldView) is before the newView, DO NOTHING except hide
          // newView will slide in on top of this one
          if (pos2 < pos1) {
            $el.addClass('animated fadeOut');
            $window.setTimeout(function () {
              $el.addClass('hide');
              $el.removeClass('fadeOut');
              ctrl.visible = false;
            }, animDuration);
          }
          // slide out to the right, revealing the new view underneath
          else if (pos2 > pos1) {
            animationClasses = 'animated slideOutRight';

            $animate.addClass($el, animationClasses).then(function () {
              $el.addClass('hide');
              ctrl.visible = false;
              $el.removeClass(animationClasses);
            });
          }
        }

      }
    });

  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    bindToController: true,
    controller: 'sbNavDrawerPageViewController',
    controllerAs: 'ctrl',
    link: link,
    require: ['sbNavDrawerPageView', '^sbNavDrawerPage'],
    restrict: 'EA',
    scope: {
      id: '@sbNavDrawerPageView',
    },
    template: '<div ng-if="ctrl.visible" class="full-height" ng-transclude></div>',
    transclude: true
  };
}

module.exports = ViewDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/view/ViewDirective.js